export default __webpack_public_path__ + "static/residence-hero-new-6a2b81a35e3611eaf0ddb627da5895ee.jpg";